<template>
  <div id="wrapper">
    <Nav :message="message" />
    <BackoutDetail />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import BackoutDetail from '@/components/revenue/BackoutDetail.vue'

export default {
  name: 'backout',
  props: ['message'],
  components: {
    Nav,
    BackoutDetail
  }
}
</script>